<template>
<div :class="$style.profile_image">
    <img
        v-if="hasImage"
        :class="$style.img"
        :src="url"
        @error="error = true">
    <svg-icon
        v-else
        :class="$style.img"
        name="ic_profile" />
</div>
</template>

<script>
import SvgIcon from "@/components/SvgIcon.vue";

export default {
    components: { SvgIcon },
    props: {
        url: { type: String, default: null }
    },
    data: () => ({ error: false }),
    computed: {
        hasImage() {
            return !this.error && this.url;
        }
    }
};
</script>

<style lang="scss" module>
.profile_image {
    display: flex;
    width: 28px;
    height: 28px;
    .img {
        width: 100%;
        height: 100%;
    }
    img {
        display: block;
        border-radius: 50%;
        object-fit: cover;
        background-color: #eef0f2;
        width: 100%;
        height: 100%;
    }
}
</style>
